import { render, staticRenderFns } from "./OptimalDosing.vue?vue&type=template&id=3af5f5f0&"
import script from "./OptimalDosing.vue?vue&type=script&lang=js&"
export * from "./OptimalDosing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports